import { render } from "./RegistroParametrosAtmosfericos.vue?vue&type=template&id=09251983&scoped=true"
import script from "./RegistroParametrosAtmosfericos.vue?vue&type=script&lang=js"
export * from "./RegistroParametrosAtmosfericos.vue?vue&type=script&lang=js"

import "./RegistroParametrosAtmosfericos.vue?vue&type=style&index=0&id=09251983&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09251983"]])

export default __exports__